import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";

const API_MENU = "https://panel.haymestasarim.com/api/public/menu";
const API_ILETISIM = "https://panel.haymestasarim.com/api/iletisim/public";
const IMAGE_BASE = "/menu/images";


/* 🌍 Tarayıcı dili */
function detectLang() {
  const l = navigator.language?.slice(0, 2);
  return ["tr", "en", "de"].includes(l) ? l : "tr";
}

/* 🔁 Flutter birebir fallback */
function resolveLang(obj, field, lang) {
  return (
    obj?.[`${field}_${lang}`] ||
    obj?.[`${field}_tr`] ||
    obj?.[`${field}_en`] ||
    obj?.[`${field}_de`] ||
    obj?.[field] ||
    ""
  );
}

/* slug */
function slugify(text) {
  return text
    .toLowerCase()
    .replaceAll("&", "ve")
    .replaceAll("ı", "i")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ş", "s")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

/* kategori resmi */
function resolveCategoryImage(category, section) {
  // 🔑 SUNUCUDAKİ SABİT DOSYA ADI
  if (section?.category_key) {
    return `${IMAGE_BASE}/${section.category_key}.jpg`;
  }

  // (opsiyonel – ileride)
  if (category?.category_key) {
    return `${IMAGE_BASE}/${category.category_key}.jpg`;
  }

  return `${IMAGE_BASE}/default.jpg`;
}


/* 🔗 Mini sosyal ikon */
/* mini sosyal icon (YENİ – GERÇEK SVG) */
function MiniIcon({ href, type }) {
  const icons = {
    instagram: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 100 10 5 5 0 000-10zm6.5-.9a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z"/>
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M23 12s0-4-1-6a3 3 0 00-2-2c-2-.5-8-.5-8-.5s-6 0-8 .5a3 3 0 00-2 2c-1 2-1 6-1 6s0 4 1 6a3 3 0 002 2c2 .5 8 .5 8 .5s6 0 8-.5a3 3 0 002-2c1-2 1-6 1-6zM10 15V9l5 3-5 3z"/>
      </svg>
    ),
    facebook: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M22 12a10 10 0 10-11.5 9.9v-7H8v-3h2.5V9.5c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.7-1.6 1.5V12H16l-.4 3h-2.3v7A10 10 0 0022 12z"/>
      </svg>
    ),
    web: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.9 9h-3a15 15 0 00-1.5-5A8 8 0 0119.9 11zM12 4c.9 1.2 1.7 3 2.1 5H9.9c.4-2 1.2-3.8 2.1-5zM4.1 13h3a15 15 0 001.5 5A8 8 0 014.1 13zm3-2h-3a8 8 0 014.4-5 15 15 0 00-1.4 5zm4.9 9c-.9-1.2-1.7-3-2.1-5h4.2c-.4 2-1.2 3.8-2.1 5zm3.5-2a15 15 0 001.5-5h3a8 8 0 01-4.5 5z"/>
      </svg>
    )
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 38,
        height: 38,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 14px rgba(0,0,0,.25)"
      }}
    >
      {icons[type]}
    </a>
  );
}



/* metinler */
const TEXT = {
  welcome: { tr: "Hoş geldiniz", en: "Welcome", de: "Willkommen" },
 search: {
  tr: "Lezzet arayın…",
  en: "Search for flavors…",
  de: "Nach Geschmack suchen…"
},


  trends: { tr: "Trend Ürünlerimiz", en: "Featured Items", de: "Trendprodukte" },


  categories: {
    tr: "Kategoriler",
    en: "Categories",
    de: "Kategorien"
  },
  categoriesSub: {
    tr: "Tüm lezzetlerimizi keşfedin",
    en: "Explore all our selections",
    de: "Entdecken Sie unsere Auswahl"
  },







  thanks: {
    tr: "Bizi tercih ettiğiniz için teşekkür ederiz",
    en: "Thank you for choosing us",
    de: "Vielen Dank, dass Sie sich für uns entschieden haben"
  }
};

/* 🔗 Sosyal ikon */
function SocialIcon({ href, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 16px rgba(0,0,0,.25)",
        fontWeight: 700,
        color: "#0b1d2d",
        textDecoration: "none"
      }}
    >
      {label}
    </a>
  );
}

export default function PublicMenu() {
  const { kurumId } = useParams();

  const [lang, setLang] = useState(detectLang());
  const [menuLangs, setMenuLangs] = useState([]);
  const [sections, setSections] = useState([]);
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(true);

  const [openSection, setOpenSection] = useState(null);
  const [openItem, setOpenItem] = useState(null);
  const [search, setSearch] = useState("");

  /* ⭐ trend modal */
  const [activeItem, setActiveItem] = useState(null);

  /* slider */
  const sliderRef = useRef(null);
  const autoRef = useRef(null);

  useEffect(() => {
    if (!kurumId) return;

    setLoading(true);

    Promise.all([
      fetch(`${API_MENU}?kurum_id=${kurumId}&lang=${lang}`).then(r => r.json()),
      fetch(`${API_ILETISIM}?kurum_id=${kurumId}&lang=${lang}`).then(r => r.json())
    ])
      .then(([menuRes, iletisimRes]) => {
        const allowed = menuRes.menu_langs?.length ? menuRes.menu_langs : ["tr"];
        setMenuLangs(allowed);

        if (!allowed.includes(lang)) {
          setLang(allowed[0]);
          return;
        }

        setContact(iletisimRes.data || {});

        const cleaned = (menuRes.sections || []).map(sec => ({
          ...sec,
          title: resolveLang(sec, "title", lang),
          categories: sec.categories.map(cat => ({
            ...cat,
            title: resolveLang(cat, "title", lang),
            items: cat.items.map(item => ({
              ...item,
              title: resolveLang(item, "title", lang),
              description: resolveLang(item, "description", lang)
            }))
          }))
        }));

        setSections(cleaned);
        setLoading(false);
      });
  }, [kurumId, lang]);

  /* ⭐ TREND */
  const trendItems = useMemo(
    () =>
      sections
        .flatMap(s => s.categories)
        .flatMap(c => c.items)
        .filter(i => i.is_trend),
    [sections]
  );

  /* 🔍 ARAMA */
  const filteredSections = useMemo(() => {
    if (!search) return sections;
    const q = search.toLowerCase();
    return sections
      .map(sec => ({
        ...sec,
        categories: sec.categories.map(cat => ({
          ...cat,
          items: cat.items.filter(
            i =>
              i.title.toLowerCase().includes(q) ||
              i.description?.toLowerCase().includes(q)
          )
        }))
      }))
      .filter(sec => sec.categories.some(c => c.items.length));
  }, [sections, search]);

  /* ▶️ auto slider */
useEffect(() => {
  if (!trendItems.length || !sliderRef.current) return;

  const slider = sliderRef.current;
  let direction = 1;

  autoRef.current = setInterval(() => {
    // sona geldiyse başa dön
    if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5) {
      slider.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }

    slider.scrollBy({
      left: 260,
      behavior: "smooth"
    });
  }, 2500);

  return () => clearInterval(autoRef.current);
}, [trendItems]);



  /* body scroll lock (PWA uyum) */
  useEffect(() => {
    document.body.style.overflow = activeItem ? "hidden" : "auto";
  }, [activeItem]);

  if (loading) {
    return <div style={{ padding: 40, textAlign: "center" }}>Menü yükleniyor…</div>;
  }

  return (
    <div style={{ background: "#f4f6f8", minHeight: "100vh" }}>
      {/* ===== HEADER ===== */}
      <header
        style={{
          background: "linear-gradient(180deg,#0b1d2d,#0f2a44,#ff8a00)",
          padding: 28,
          color: "#fff",
          textAlign: "center"
        }}
      >
        <h1 style={{ fontSize: "clamp(22px,5vw,34px)", fontWeight: 800 }}>
          {contact.kurum_adi}
        </h1>
        <div>{TEXT.welcome[lang]}</div>

        <div style={{ marginTop: 12, display: "flex", justifyContent: "center", gap: 8 }}>
          {menuLangs.map(l => (
            <button
              key={l}
              onClick={() => setLang(l)}
              style={{
                padding: "6px 14px",
                borderRadius: 999,
                fontWeight: 700,
                border: "1px solid #ffffff55",
                background: l === lang ? "#ff8a00" : "transparent",
                color: l === lang ? "#0b1d2d" : "#fff"
              }}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>

       <input
  value={search}
  onChange={e => setSearch(e.target.value)}
  placeholder={TEXT.search[lang]}
  style={{
    marginTop: 16,
    width: "100%",
    maxWidth: 420,
    padding: 14,
    borderRadius: 14,
    border: "none",
    background: "#ffffff",
    color: "#0b1d2d",
    fontSize: 16,
    fontWeight: 600,
    boxShadow: "0 6px 18px rgba(0,0,0,.15)"
  }}
/>
      </header>

      {/* ===== TREND SLIDER (AUTO) ===== */}
      {trendItems.length > 0 && (
        <section style={{ padding: 20 }}>
{/* ===== TREND BAŞLIK (KATEGORİLER İLE AYNI) ===== */}
<div
  style={{
    textAlign: "center",
    marginBottom: 16
  }}
>
  <h2
    style={{
      fontSize: "clamp(22px, 5vw, 28px)",
      fontWeight: 800,
      marginBottom: 6,
      color: "#0b1d2d"
    }}
  >
    ⭐ {TEXT.trends[lang]}
  </h2>

  <div
    style={{
      width: 60,
      height: 4,
      margin: "0 auto",
      borderRadius: 4,
      background: "#ff8a00"
    }}
  />
</div>
          <div
            ref={sliderRef}
            style={{
              display: "flex",
              gap: 16,
              overflowX: "auto",
              scrollBehavior: "smooth",
              paddingBottom: 12
            }}
            onTouchStart={() => clearInterval(autoRef.current)}
          >
            {trendItems.map(item => (
              <div
                key={item.id}
                onClick={() => setActiveItem(item)}
                style={{
                  minWidth: 240,
                  background: "#fff",
                  borderRadius: 18,
                  cursor: "pointer",
                  boxShadow: "0 10px 26px rgba(0,0,0,.15)"
                }}
              >
                <img
                  src={item.image}
                  alt=""
                  style={{
                    width: "100%",
                    height: 150,
                    objectFit: "cover",
                    borderTopLeftRadius: 18,
                    borderTopRightRadius: 18
                  }}
                />
                <div style={{ padding: 12 }}>
                  <strong>{item.title}</strong>
                  <div style={{ color: "#ff8a00", fontWeight: 700 }}>
                    {item.price} {item.currency}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}


{/* ===== KATEGORİ GEÇİŞ BAŞLIĞI ===== */}
<section
  style={{
    marginTop: 10,
    marginBottom: 10,
    padding: "32px 16px 12px",
    textAlign: "center",
    background:
      "linear-gradient(180deg, rgba(244,246,248,1) 0%, rgba(244,246,248,0) 100%)"
  }}
>
  <h2
    style={{
      fontSize: "clamp(22px, 5vw, 28px)",
      fontWeight: 800,
      marginBottom: 6,
      color: "#0b1d2d"
    }}
  >
    {TEXT.categories[lang]}
  </h2>

  <div
    style={{
      fontSize: 14,
      color: "#666",
      marginBottom: 14
    }}
  >
    {TEXT.categoriesSub[lang]}
  </div>

  <div
    style={{
      width: 60,
      height: 4,
      margin: "0 auto",
      borderRadius: 4,
      background: "#ff8a00"
    }}
  />
</section>



{/* ===== KATEGORİLER (ESKİ USUL – GÖRSELLİ) ===== */}
<div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
  {filteredSections.map(sec =>
    sec.categories.map(cat => {
      const isOpen = openSection === cat.id;

      return (
        <div
          key={cat.id}
          style={{
            marginBottom: 24,
            borderRadius: 18,
            overflow: "hidden",
            background: "#fff",
            boxShadow: "0 8px 22px rgba(0,0,0,.12)"
          }}
        >
          {/* === KATEGORİ KARTI === */}
          <div
            onClick={() =>
              setOpenSection(isOpen ? null : cat.id)
            }
            style={{
              position: "relative",
height: "clamp(140px, 30vw, 200px)",
              cursor: "pointer"
            }}
          >
  <img
  src={resolveCategoryImage(cat, sec)}
  onError={e => (e.currentTarget.src = `${IMAGE_BASE}/default.jpg`)}
  alt={cat.title}
  style={{
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "brightness(.7)"
  }}
/>


            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 22,
                fontWeight: 800,
                letterSpacing: 1
              }}
            >
              {cat.title}
            </div>
          </div>

          {/* === ALT ÜRÜNLER === */}
          {isOpen && (
            <div
              style={{
                padding: 16,
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: 16
              }}
            >
              {cat.items.map(item => (
                <div
                  key={item.id}
                  onClick={() => setActiveItem(item)}
                  style={{
                    background: "#fafafa",
                    borderRadius: 14,
                    overflow: "hidden",
                    cursor: "pointer",
                    boxShadow: "0 6px 16px rgba(0,0,0,.08)"
                  }}
                >
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "100%",
aspectRatio: "4 / 3",
                        objectFit: "cover"
                      }}
                    />
                  )}

                  <div style={{ padding: 12 }}>
                    <strong>{item.title}</strong>

                    <div
                      style={{
                        color: "#ff8a00",
                        fontWeight: 700,
                        marginTop: 4
                      }}
                    >
                      {item.price} {item.currency}
                    </div>

                    {item.description && (
                      <div
                        style={{
                          fontSize: 14,
                          color: "#555",
                          marginTop: 6
                        }}
                      >
                        {item.description}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    })
  )}
</div>



         {/* FOOTER */}
     <footer
  style={{
    background: "#0b1d2d",
    padding: "40px 16px 32px",
    color: "#fff"
  }}
>
  {/* TURUNCU KART */}
  <div
    style={{
      background: "#ff8a00",
      borderRadius: 18,
      padding: "24px 20px",
      maxWidth: 420,
      margin: "0 auto 32px",
      color: "#0b1d2d",
      boxShadow: "0 12px 30px rgba(0,0,0,.35)"
    }}
  >

    <div
      style={{
        fontSize: 20,
        fontWeight: 700,
        marginBottom: 6
      }}
    >
      {TEXT.thanks[lang]}
    </div>

  
    {/* SOSYAL ICONLAR */}
    <div
      style={{
        display: "flex",
        gap: 12,
        justifyContent: "center"
      }}
    >
     {contact.instagram && <MiniIcon href={contact.instagram} type="instagram" />}
{contact.youtube && <MiniIcon href={contact.youtube} type="youtube" />}
{contact.facebook && <MiniIcon href={contact.facebook} type="facebook" />}
{contact.website && <MiniIcon href={contact.website} type="web" />}
    </div>
  </div>

  {/* ALT BİLGİ */}
  <div
    style={{
      textAlign: "center",
      fontSize: 14,
      color: "#c7d0d9",
      lineHeight: "22px"
    }}
  >
    {contact.adres && <div>📍 {contact.adres}</div>}
    {contact.telefon && <div>📞 {contact.telefon}</div>}
    {contact.saat && <div>🕒 {contact.saat}</div>}
  </div>

    </footer>

      {/* ===== MODAL ===== */}
      {activeItem && (
        <div
          onClick={() => setActiveItem(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 20,
              maxWidth: 420,
              width: "90%",
              overflow: "hidden"
            }}
          >
            <img src={activeItem.image} alt="" style={{ width: "100%", height: 220, objectFit: "cover" }} />
            <div style={{ padding: 16 }}>
              <h2>{activeItem.title}</h2>
              <div style={{ color: "#ff8a00", fontWeight: 800 }}>
                {activeItem.price} {activeItem.currency}
              </div>
              <p>{activeItem.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
